import { useHistory } from '@fs/zion-router'
import React, { useMemo } from 'react'
import { SortableResponsiveTable, ResponsiveTableRow, useSortableTable, MarginBox } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePlaceReportsPageData } from '../../PlaceReportsProvider'
import { getLocaleName, propertySort } from '../../placeReportsHelper'
import ContentWrapper from '../../ContentWrapper'

const columnProperties = {
  column1: 'name',
  column2: 'score',
}

export default function PlaceReportsRegionsNavPanel() {
  const [t] = useTranslation()
  const { reportsIndex } = usePlaceReportsPageData()
  const history = useHistory()

  const sortable = useSortableTable('column1', true)
  const { sortedColumnId, ascending } = sortable

  const sortedData = useMemo(
    () => reportsIndex?.regions.sort(propertySort(columnProperties[sortedColumnId], ascending)),
    [ascending, sortedColumnId, reportsIndex]
  )

  return (
    <ContentWrapper>
      <MarginBox marginX="nano" marginY="sm">
        <SortableResponsiveTable
          {...sortable}
          atSizeColumns={{ default: { labels: [t('place-reports.nav-panel.region.label', 'Region')] } }}
          sortableColumns={['column1']}
          stickyHeader
          totalColumnCount={1}
          separator={<br />}
        >
          {sortedData.map((item) => {
            const { id, name } = item
            return (
              <ResponsiveTableRow
                key={id}
                column1={getLocaleName(name)}
                onClick={() => {
                  history.push(`/place-reports/?region=${id}`)
                }}
              />
            )
          })}
        </SortableResponsiveTable>
      </MarginBox>{' '}
    </ContentWrapper>
  )
}
